import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { DISABLED_LOADING_INTERCEPTOR } from "@core/constants";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";

@Injectable({
  providedIn: "root"
})
export class LoadingInterceptor implements HttpInterceptor {
  handleRequestsAutomatically: boolean;

  constructor(private loadingDrivebService: LoadingDrivebService) {
    // Subscribe to the auto
    this.loadingDrivebService.auto$.subscribe((value) => {
      this.handleRequestsAutomatically = value;
    });
  }

  intercept<T>(
    req: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const newReq: any = req;

    if (req.url.endsWith("/") && !req.url.endsWith(".json/")) {
      newReq.url = req.url.slice(0, -1);
    }

    const disabledLoadingInterceptorHeader = newReq.headers.get(
      DISABLED_LOADING_INTERCEPTOR
    );

    if (disabledLoadingInterceptorHeader) {
      return next.handle(newReq);
    }

    // If the Auto mode is turned off, do nothing
    if (!this.handleRequestsAutomatically) {
      return next.handle(newReq);
    }

    // Set the loading status to true
    this.loadingDrivebService._setLoadingStatus(true, newReq.url);

    return next.handle(newReq).pipe(
      finalize(() => {
        // Set the status to false if there are
        // any errors or the newRequest is completed
        this.loadingDrivebService._setLoadingStatus(false, newReq.url);
      })
    );
  }
}
